export default __webpack_public_path__ + "static/media/Nattersearch.17ab7a11.mp4";